<template>
    <div class="container">
        <div class="banner">
            <img :src="bannerUrl?bannerUrl:require('@/assets/banner_com.png')" />
        </div>
        <div class="content">
            <el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
                <el-tab-pane v-for="(item,index) in navList" :key="index" :label="item.categoryName" :name="item.id+''">
                </el-tab-pane>
            </el-tabs>
            <!-- <div class="swiper-container">
				<div class="swiper-wrapper">
					<div @click="changeTab(index, item.id)" :class="[activeIndex==index?'active':'']" class="swiper-slide" v-for="(item,index) in navList" >
						{{item.categoryName}}
					</div>
					<span class="swiper-line"></span>
				</div>
				<div class="swiper-mask swiper-mask-l"></div>
				<div class="swiper-mask swiper-mask-r"></div>
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
			</div> -->
            <!-- <ul class="menu-wrap">
				<li>进行中</li>
				<li class="active">进行中</li>
				<li>进行中</li>
			</ul> -->
            <div v-if="dataList.length>0">
                <div v-for="(item,index) in dataList" class='listBox' :key="index">
                    <BannerTop :comItem="item" :isLine2=true />
                </div>
            </div>
            <Empty content="该分类下无数据" v-else />
            <div v-if="total>pageSize">
                <Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange" />
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import Swiper from "swiper"
import 'swiper/dist/css/swiper.css'
import BannerTop from '@/components/competition/bannerTop'
import Pagination from '@/components/pagination'
import Empty from '@/components/empty'
export default {
    name: 'competition',
    components: {
        BannerTop,
        Pagination,
        Empty
    },
    data() {
        return {
            activeIndex: 0,
            mySwiper: null,
            navList: [],
            pageSize: 10,
            pageNum: 1,
            categoryId: '', //分类id
            userId: '',
            dataList: [],
            total: 0,
            activeTab: '',
            bannerUrl: ''
        }
    },
    created() {
        this.userId = localStorage.getItem('userId')
        this.getConfigData()
        setTimeout(res => {
            console.log(res)
            this.initSwiper()
        }, 300)
        this.getNavList()
    },
    methods: {
        //获取大赛页banner图
        async getConfigData() {
            let param = {
                code: 'CIRCLE_COMPETE_BANNER'
            }
            ajaxParam(param)
            const res = await post('v1/sysConfig/getConfigByCode', qs.stringify(param))
            if (res.data.code == 200) {
                if (res.data.entity.configValue) {
                    this.bannerUrl = res.data.entity.configValue
                }
            } else {
                this.$message.error(res.data.msg)
            }
        },
        handleClick(tab, event) {
            let name = tab.name
            this.categoryId = name
            this.dataList = []
            this.pageNum = 1
            this.getDataList()
        },
        initSwiper() {
            this.mySwiper = new Swiper(".swiper-container", {
                // 轮播效果,默认为平滑轮播
                effect: "slide",
                // 如果需要前进后退按钮
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                slidesPerView: 'auto'
            })
        },
        //获取大赛分类数据
        async getNavList() {
            let param = {}
            ajaxParam(param)
            const res = await post('v1/competition/competitionCategory', qs.stringify(param))
            if (res.data.code == 200) {
                console.log(res.data)
                this.navList = res.data.list
                if (this.navList.length > 0) {
                    this.categoryId = this.navList[0].id
                    this.activeTab = this.navList[0].id + ''
                    this.getDataList()
                }
            } else {
                this.$message.error(res.data.msg)
            }
        },
        //获取大赛数据列表
        async getDataList() {
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                categoryId: this.categoryId,
                userId: this.userId
            }
            ajaxParam(param)
            const res = await post('v1/competition/competitionList', qs.stringify(param))
            if (res.data.code == 200) {
                this.dataList = res.data.list
                this.total = res.data.total
            } else {
                this.$message.error(res.data.msg)
            }
        },
        changeTab(index, id) {
            this.activeIndex = index;
            this.categoryId = id
            //点击栏目名称显示不同栏目数据
            this.dataList = []
            this.pageNum = 1
            this.getDataList()

        },
        pageChange(e) {
            this.dataList = []
            this.pageNum = e.number
            this.getDataList()
        }
    }
}
</script>
<style lang="less" scoped>
.container {
    .banner {
        img {
            width: 100%;
        }
    }

    .listBox {
        cursor: pointer;
    }

    .content {
        width: 1180px;
        margin: 20px auto;
        padding: 6px 40px 40px;
        background: #fff;
        border-radius: 12px;
        box-sizing: border-box;
        overflow: hidden;

        .competition {
            border: 1px solid #e2e2e2;
        }

        .swiper-container {
            margin: 20px 10px;

            .swiper-wrapper {
                position: relative;
                width: auto !important;
                height: 100%;

                .swiper-slide {
                    width: auto !important;
                    margin-right: 15px !important;
                    padding: 10px 2px;
                    margin: 0 20px;
                    cursor: pointer;
                }

                .active {
                    border-bottom: 4px solid #DD0515;
                }

                .swiper-line {
                    position: absolute;
                    height: 3px;
                    background: #000;
                    left: 1%;
                    top: 85%;
                }
            }

            .swiper-button-prev,
            .swiper-button-next {
                transform: scale(.6);
            }

            .swiper-button-prev {
                left: -5px;
            }

            .swiper-button-next {
                right: -6px;
            }
        }

        .menu-wrap {
            display: flex;
            align-items: center;
            font-size: 18px;

            li {
                padding: 12px 0 12px;
                margin-left: 30px;
                line-height: 32px;
                color: #323232;
                opacity: .8;
                border-bottom: 4px solid #fff;
                cursor: pointer;
            }

            li.active {
                opacity: 1;
                font-weight: bold;
                border-color: #DD0515;
            }
        }
    }

    .swiper-mask {
        width: 30px;
        height: 20px;
        background: linear-gradient(to right, transparent 0%, #fff 100%);
        opacity: .9;
        z-index: 2;
        position: absolute;

        top: 10px;
    }

    .swiper-mask-l {
        background: linear-gradient(to left, transparent 0%, #fff 100%);
        left: 0;
    }

    .swiper-mask-r {
        right: 0;
    }

    /deep/ .el-tabs__item {
        height: 42px;
        line-height: 42px;
        font-size: 16px;
    }

    /deep/ .el-tabs__active-bar {
        background-color: #DD0515;
    }

    /deep/ .el-tabs__item.is-active {
        color: #DD0515;
    }

    /deep/ .el-tabs__item:hover {
        color: #DD0515;
    }

    /deep/ .el-tabs__header {
        margin-bottom: 0;
    }
}
</style>